import { FormInstance } from 'antd';
import { UseMutationResult } from 'react-query';
import {
    ClientType,
    NouveauDossierConcessionnaireData,
    RAI,
} from 'types/Concessionnaire';
import Step3PersonneMorale from 'views/dossiers/concessionnaire/steps/Step3PersonneMorale';
import Step3PersonnePhysique from 'views/dossiers/concessionnaire/steps/Step3PersonnePhysique';

type Props = Omit<
  UseMutationResult<
    {
      id: string;
      volume: number;
      prime: number;
    },
    Error,
    {
      particulier: boolean;
      formData: FormData;
    },
    unknown
  >,
  'data' | 'error' | 'reset'
> & {
  data?: {
    id: string;
    volume: number;
    prime: number;
  };
  error?: Error | null;
  form: FormInstance<NouveauDossierConcessionnaireData>;
  isLoadingPrime?: boolean;
  primeParGwh?: number;
  primeParVehicule?: number;
  goToPreviousStep(): void;
  volume?: number;
  rai?: RAI;
  showActions?: boolean;
  showError?: boolean;
  reset(): void;
};

export default function Step3(props: Props) {
  const { form } = props;
  const typeClient = form.getFieldValue('typeClientFinal');
  const personnePhysique = typeClient === ClientType.PERSONNE_PHYSIQUE;

  if (personnePhysique) {
    return <Step3PersonnePhysique {...props} />;
  }

  return <Step3PersonneMorale {...props} />;
}
